<template>
    <Sidebar v-model:visible="$store.state.planning.display" position="full" :baseZIndex="1000" >
        <Toast/>
		<div class="p-grid">
			<div class="p-col-12 p-md-12 p-lg-8">
				<div class="ttitle">{{$t('Detail')}}: {{title}}</div>
			</div>
			<div class="p-col-12 p-md-12 p-lg-4">
				<Button :label="$t('Home')" style="width: 30%;" icon="pi pi-home" class="p-button-secondary p-mr-2 p-mb-2" @click="Home()"/>
				<Button :label="$t('Save')" style="width: 30%;" icon="pi pi-save" class="p-button-secondary p-mr-2 p-mb-2" @click="SaveAll()" :disabled="$store.state.planning.editing.length>0"/>
				<Button :label="$t('Close')" style="width: 30%;" icon="pi pi-times" class="p-button-secondary p-mr-2 p-mb-2" @click="Closed()"/>
				<ProgressBar :value="porc" style="width: 90%;"/>	
			</div>	
            <div class="p-col-12 p-md-12 p-lg-12">
				<Analy_Plan v-if="step==0"/>
				<Monitoring_Control v-if="step==1"/>
            </div>
			{{error}}
		</div>
    </Sidebar>
</template>

<script>
	import API from "../service/API";
	import { useI18nPlugin } from '@unify/vuex-i18n';
	import Token from "uuid-token-generator";
	import { defineAsyncComponent } from "@vue/runtime-core";

	export default {
        components: {
            Analy_Plan: defineAsyncComponent(() => import('./eval/Analy_Plan.vue')),
			Monitoring_Control: defineAsyncComponent(() => import('./eval/Monitoring_Control.vue')),
        },
		props: {
			title: {
				type: Object,
				default: null,
			},
			step: {
				type: Number,
				default: 0,
			},
		},
		data() {
			return {
				i18n: null,
				url: null,
				img: null,
				porc: 0,
				heigt_sc: 0,
				editingRows: [],
				expandedRows: [],
				editing: [],
				product: null,
				error:null,
				steps: [
					'AnalyPlanning',
					'Monitoring',
				],
			}
		},
		productService: null,
		created() {
			this.i18n = useI18nPlugin();
			this.url = process.env.VUE_APP_API;
			const tokgen = new Token(256);
			this.img = tokgen.generate();
			if(this.$store.state.screen<=728){
				this.heigt_sc =  380;
			} else {
				this.heigt_sc =  500;
			}
			this.Calc();
		},
		mounted() {
			
		},
		methods: {
			Home() {
				this.Closed();
				this.$router.push({ path: '/' });
			},
			SaveAll() {
				var Consult = new API('Evaluation',this.steps[this.step]);
                Consult.Process('UPD',{
					inf: this.$store.state.planning
				}).then(response => {
					//this.error = response;
					this.$toast.add(Consult.Mens(response.result,this.i18n.locale()));
					if (response.result) {
						this.$store.state.planning.detail = response.result.answers;
						this.Calc();
					} 				
				});
			},
            Closed(){
				this.onSave();
				this.$store.state.planning.display = false;
				this.$store.state.planning.detail = [];
				this.$store.state.planning.data = null;
				this.$store.state.planning.editing = [];
			},
			onSave(event) {
				this.$emit('save-close', event);
			},
			ViewPDF(document){
				window.open(this.url+'/upload/'+document, '_blank');
			},
			Calc(){
				let porc = 0;
				let total = 0;
				let detail = this.$store.state.planning.detail;
				detail.forEach(element => {
					if(element.status==4){
						porc =  parseInt(porc) + 1;
					}
					total = parseInt(total) + 1;
				});
				if(porc>0){
					this.porc = (parseInt(porc)*100/parseInt(total)).toFixed(1);
				} else {
					this.porc = 0;
				}
			},
			
		}
	}
</script>
<style scoped lang="scss">
.cheap {
	background-color: #54a90a !important;
	color: #ffffff !important;
}

.edit_tab{
	padding: 10px 10px 10px 10px;
	font-size: 10px;
	color: red;
}

.ttitle{
    font-family: 'Rajdhani', sans-serif;
    font-size: calc(0.7rem + 1vw);
    font-weight: 600;
    color: #2b3b80;
    padding: 1em 0em 1em 0.5em;
}
.text-title{
    font-family: 'Rajdhani', sans-serif;
    font-size: calc(0.7rem + 1vw);
    font-weight: 600;
    color: #2b3b80;
}

.p-datatable .p-column-filter {
	display: none;
}

.table-header {
	display: flex;
	justify-content: space-between;
}

::v-deep(.p-datatable.p-datatable-customers) {
	.p-datatable-header {
		padding: 1rem;
		text-align: left;
		font-size: 1.5rem;
	}

	.p-paginator {
		padding: 1rem;
	}

	.p-datatable-thead > tr > th {
		text-align: left;
	}

	.p-datatable-tbody > tr > td {
		cursor: auto;
	}

	.p-dropdown-label:not(.p-placeholder) {
		text-transform: uppercase;
	}
}

/* Responsive */
.p-datatable-customers .p-datatable-tbody > tr > td .p-column-title {
	display: none;
}

.customer-badge {
	border-radius: 2px;
	padding: .25em .5rem;
	text-transform: uppercase;
	font-weight: 700;
	font-size: 12px;
	letter-spacing: .3px;

	&.status-qualified {
		background: #C8E6C9;
		color: #256029;
	}

	&.status-unqualified {
		background: #FFCDD2;
		color: #C63737;
	}

	&.status-negotiation {
		background: #FEEDAF;
		color: #8A5340;
	}

	&.status-new {
		background: #B3E5FC;
		color: #23547B;
	}

	&.status-renewal {
		background: #ECCFFF;
		color: #694382;
	}

	&.status-proposal {
		background: #FFD8B2;
		color: #805B36;
	}
}

@media (max-width: 640px) {

	
}

.product-image {
	width: 100px;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)
}

.orders-subtable {
	padding: 1rem;
}

.product-badge {
	border-radius: 2px;
	padding: .25em .5rem;
	text-transform: uppercase;
	font-weight: 700;
	font-size: 12px;
	letter-spacing: .3px;

	&.status-instock {
		background: #C8E6C9;
		color: #256029;
	}

	&.status-outofstock {
		background: #FFCDD2;
		color: #C63737;
	}

	&.status-lowstock {
		background: #FEEDAF;
		color: #8A5340;
	}
}

.order-badge {
	border-radius: 2px;
	padding: .25em .5rem;
	text-transform: uppercase;
	font-weight: 700;
	font-size: 12px;
	letter-spacing: .3px;

	&.order-delivered {
		background: #C8E6C9;
		color: #256029;
	}

	&.order-cancelled {
		background: #FFCDD2;
		color: #C63737;
	}

	&.order-pending {
		background: #FEEDAF;
		color: #8A5340;
	}

	&.order-returned {
		background: #ECCFFF;
		color: #694382;
	}
}

@media screen and (max-width: 960px) {
	::v-deep(.p-datatable) {
		&.p-datatable-customers {
			.p-datatable-thead > tr > th,
			.p-datatable-tfoot > tr > td {
				display: none !important;
			}

			.p-datatable-tbody > tr {
				> td {
					text-align: left;
					display: block;
					border: 0 none !important;
					width: 100% !important;
					float: left;
					clear: left;
					border: 0 none;

					.p-column-title {
						padding: .4rem;
						min-width: 30%;
						display: inline-block;
						margin: -.4rem 1rem -.4rem -.4rem;
						font-weight: bold;
					}


				}
			}
		}
	}
}
</style>